import { render, staticRenderFns } from "./PointList.vue?vue&type=template&id=5d45b0e9"
import script from "./PointList.vue?vue&type=script&lang=js"
export * from "./PointList.vue?vue&type=script&lang=js"
import style0 from "./PointList.vue?vue&type=style&index=0&id=5d45b0e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports